import axios from 'axios';
import { ENDPOINT } from './auth'; // reuse base ENDPOINT

// Helper ensures auth header is already set by AuthContext

export const fetchProducts = () => {
  return axios.get(`${ENDPOINT}?action=getProducts`);
};

export const getCategories = () => {
  const token = localStorage.getItem('token');
  return axios.get(`${ENDPOINT}?action=getCategories`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
};

export const addProduct = (data) => {
  return axios.post(`${ENDPOINT}?action=addProduct`, data);
};

export const updateProduct = (data) => {
  return axios.post(`${ENDPOINT}?action=updateProduct`, data);
};

export const updateProductStatus = (data) => {
  return axios.post(`${ENDPOINT}?action=updateProductStatus`, data);
};

export const deleteProduct = (product_id) => {
  return axios.post(`${ENDPOINT}?action=deleteProduct`, {
    product_id,
  });
};

// Fetch products that are currently at or below their low-stock threshold
export const getLowStockProducts = () => {
  const token = localStorage.getItem('token');
  return axios.get(`${ENDPOINT}?action=getLowStockProducts`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
};

// Fetch low stock products by category (optional)
// Uses backend action getLowStockProductsWithCategories which expects JSON body { category_id }
export const getLowStockProductsByCategory = (category_id) => {
  if (!category_id) {
    const token = localStorage.getItem('token');
    return axios.get(`${ENDPOINT}?action=getLowStockProducts`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
  }
  const token = localStorage.getItem('token');
  return axios.post(`${ENDPOINT}?action=getLowStockProductsWithCategories`, { category_id }, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
};
